import {Component, OnInit, ViewChild} from '@angular/core';
import {changePwd} from "../../models/changePwd";
import * as CryptoJS from 'crypto-js';
import {UserService} from "../../Services/Users.service";
import {NgForm} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
declare var $;


@Component({
  selector: 'app-isolated-pwd-change',
  templateUrl: './isolated-pwd-change.component.html',
  styleUrls: ['./isolated-pwd-change.component.css']
})
export class IsolatedPwdChangeComponent implements OnInit {

  @ViewChild('passForm') passForm: NgForm;
  @ViewChild('chnagePswForm') chnagePswForm: NgForm;

  changePwdObj = new changePwd();
  pwdErrorCode : string;
  idFlag : boolean = false;
  userid:string;
  newPassword:string;
  password:string;
  validationMsg:string = '';
  loginMsg = '';
  isDataShow: boolean = false;
  screenWidth: number = 1366;
  redirectUrl: string = '';
  passwordType: boolean = false;

  constructor(private userService: UserService, private router : Router, private route: ActivatedRoute, private translateService: TranslateService) {
    let lang_name = localStorage.getItem('defaultLang') ? localStorage.getItem('defaultLang') : 'English';
    this.translateService.use(lang_name);
    this.translateService.reloadLang(lang_name);
  }

  ngOnInit() {
    $(document).ready(function() {
      $("#disablePrevent").on("contextmenu",function(){
        return false;
      });
    });
    $("header").css('display','none');
    $("footer").css('display','none');
    $("body").addClass("isolatedBg");
    $("#preloader").css('display', 'none');
    window.name = 'isolatedNewUserScreen';
    this.screenWidth = screen.width || window.screen.width;
    window.addEventListener("orientationchange", () => {
      if (window.orientation == 90) {
        this.screenWidth = screen.width || window.screen.width;
      } else {
        this.screenWidth = screen.width || window.screen.width;
      }
    });
    this.route.params.subscribe(params => {
      let idflag = false;
      let urlflag = false;
      let id = '';
      let strUrl = '';
      if(params['id']){
        id = params['id'];
        if(id && id.includes('http')){
          this.redirectUrl = decodeURIComponent(id);
          idflag = true;
        }else{
          if(params['url']){
            strUrl = params['url'];
            if(strUrl && strUrl.includes('http')){
              this.redirectUrl = decodeURIComponent(strUrl);
              urlflag = true;
            }
          }
          this.userid = id;
          this.IsForChangePassword(id);
          this.isDataShow = true;
          this.idFlag = true;
          this.loginMsg = '';
          // In a real app: dispatch action to load the details here.
        }
      }

      if(idflag || !(params['id'])){
        this.idFlag = false;
        $("#preloader").css('display','block');
        const theCommunity = JSON.parse(localStorage.getItem('currentUser'));
        let Role = localStorage.getItem('userRole');
        if(Role && (Role == 'Learner' || Role == 'Manager')){
          if(theCommunity && theCommunity.user.userid){
            this.changePwdObj.user_id = theCommunity.user.userid;
            this.isDataShow = true;
            $("#preloader").css('display','none');
          }else{
            $("#preloader").css('display','none');
            this.loginMsg = '200';
            this.isDataShow = false;
            this.validationMsg = '';
            $('#profilesuccessModal').modal('show');
            // this.router.navigate(['/isolatedLogin']);
          }
        }else{
          $("#preloader").css('display','none');
          this.loginMsg = '201';
          this.isDataShow = false;
          this.validationMsg = '';
          $('#profilesuccessModal').modal('show');
        }

      }
    });
  }

  changePasswordType() {
    this.passwordType = !this.passwordType
  }

  updatePassword(passForm){
    if(this.idFlag){
      let changePwdObj = {
        userid : this.changePwdObj.user_id,
        newPassword : this.changePwdObj.re_password,
        password : this.changePwdObj.re_password
      };

      let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(changePwdObj), '#Alignor Credentials#').toString();
      let authentication = {
        authentication: ciphertext
      };

      this.userService.changePassword(authentication)
        .subscribe(user => {
          if(user.success){
            $('#successModal').modal('show');
          } else {
            // this.validationMsg = user.message;
          }
        });
    }else{
      $("#preloader").css('display','block');
      const currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if(currentUser && currentUser.user && currentUser.user.userid){
        this.changePwdObj.user_id = currentUser.user.userid;
        this.changePwdObj.updated_by = currentUser.user.userid;

        let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(this.changePwdObj), '#Alignor Credentials#').toString();
        let authentication = {
          authentication: ciphertext
        };

        this.userService.updatePassword(authentication).subscribe(user =>{
          this.pwdErrorCode = user.statusCode;
          if(user.success){
            passForm.reset();
            // $('#changePwdMoal').modal('hide');
            $("#preloader").css('display','none');
            $('#profilesuccessModal').modal('show');
          }else{
            $("#preloader").css('display','none');
          }
        });
      }else{
        this.loginMsg = '200';
        this.validationMsg = '';
        this.isDataShow = false;
        $("#preloader").css('display','none');
        $('#profilesuccessModal').modal('show');
      }
    }

  }

  closeSuccessModal(){
    $('#profilesuccessModal').modal('hide');
    this.pwdErrorCode = '';
    if(this.passForm){
      this.passForm.reset();
    }
    if(this.chnagePswForm){
      this.chnagePswForm.reset();
    }
    this.loginMsg = '';
    this.validationMsg = '';
    this.isDataShow = false;
    if(this.redirectUrl != ''){
      location.replace(this.redirectUrl);
    }else{
      window.close();
    }
  }

  clearFlag(){
    this.pwdErrorCode = '';
  }

  IsForChangePassword(id:any){
    this.userService.IschangePassword(id)
      .subscribe(result => {
        if (result.data == '' || result.data == null) {
          this.router.navigate(['/isolatedLogin']);
        }else{
          this.userid = result.data[0];
        }
      });
  }

  changePassword(chnagePswForm){
    let changePwdObj = {
      userid : this.userid,
      newPassword : this.newPassword,
      password : this.password
    };

    let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(changePwdObj), '#Alignor Credentials#').toString();
    let authentication = {
      authentication: ciphertext
    };

    this.userService.changePassword(authentication)
      .subscribe(user => {
        if(user.success){
          $('#profilesuccessModal').modal('show');
          this.pwdErrorCode = '200';
          this.validationMsg = '';
        } else {
          this.validationMsg = user.message;
        }
      });
  }
  ngOnDestroy(){
    $("body").removeClass("isolatedBg");
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/isolated-pwd-change/isolated-pwd-change.component.ts